import { TUsersStoreState } from './types';

export function getUsers(state: TUsersStoreState) {
  return state.users;
}
